import AssetsDetails from "./AssetsDetails";
import AssetsLeftFilter from "./AssetsLeftFilter";

export { AssetsDetails, AssetsLeftFilter };



// WEBPACK FOOTER //
// ./src/components/AssetsWrapper/index.js